import aiVideoMP4 from '../video/product/ai/ai-hero.mp4'
import aiVideoWebm from '../video/product/ai/ai-hero.webm'
import insightsVideoMP4 from '../video/product/insights.mp4'
import insightsVideoWebm from '../video/product/insights.webm'
import okrVideoMP4 from '../video/product/objectives/okr-hero.mp4'
import okrVideoWebm from '../video/product/objectives/okr-hero.webm'
import portalVideoMP4 from '../video/product/portal.mp4'
import portalVideoWebm from '../video/product/portal.webm'
import prioritizationVideoMP4 from '../video/product/prioritization.mp4'
import prioritizationVideoWebm from '../video/product/prioritization.webm'
import roadmapsVideoMP4 from '../video/product/roadmaps.mp4'
import roadmapsVideoWebm from '../video/product/roadmaps.webm'

export interface AdGalleryContentProps {
  name: { en: string; fr?: string; de?: string }
  title: { en: string; fr?: string; de?: string }
  description: { en: string; fr?: string; de?: string }
  imgSrc?: string
  mp4VideoSrc?: string
  webmVideoSrc?: string
}

export const adGalleryContent: AdGalleryContentProps[] = [
  {
    name: { en: 'ROADMAPS', fr: 'FEUILLES DE ROUTE' },
    title: {
      en: 'Create clear & custom roadmaps <br class="hide-on-small hide-on-large-desktop" /> in minutes',
      fr: 'Créez des roadmaps claires et personnalisées en quelques instants',
    },
    description: {
      en: 'Build clear roadmaps that align everyone with an intuitive drag-and-drop interface. Seamlessly export your custom roadmaps views and share with different target audiences.',
      fr: 'Créez des roadmaps claires qui harmonisent vos équipes grâce à une interface intuitive de type "glisser-déposer". Exportez de manière lisible les vues de vos roadmaps personnalisées et partagez-les avec vos audiences ciblées.',
    },
    mp4VideoSrc: roadmapsVideoMP4,
    webmVideoSrc: roadmapsVideoWebm,
  },
  {
    name: { en: 'PRIORITIZATION', fr: 'PRIORISATION' },
    title: {
      en: 'Make the right decisions and build products <br class="hide-on-small hide-on-large-desktop" /> that meet market demands',
      fr: 'Prenez les bonnes décisions et fabriquez des produits qui répondent aux aux exigences de votre marché',
    },
    description: {
      en: 'Ensure that all relevant inputs from different stakeholders are included in the prioritization process and make group prioritization effective and easy.',
      fr: 'Faites en sorte que les contributions pertinentes de vos équipes soient bien intégrées dans votre process et que la hiérarchisation des groupes soit efficace.',
    },
    mp4VideoSrc: prioritizationVideoMP4,
    webmVideoSrc: prioritizationVideoWebm,
  },
  {
    name: { en: 'INSIGHTS', fr: 'INSIGHTS' },
    title: {
      en: 'Understand what customers need <br class="hide-on-small hide-on-large-desktop" /> and build better products',
      fr: 'Comprenez les besoins de vos clients et crééz de meilleurs produits',
    },
    description: {
      en: 'Capture, centralize, and organize feedback all in one place. Turn them into insights to keep solving the right problems for your customers.',
      fr: 'Intégrez, centralisez et triez les feedback en un seul endroit. Transformez-les en informations pour continuer à résoudre les problèmes de vos clients.',
    },
    mp4VideoSrc: insightsVideoMP4,
    webmVideoSrc: insightsVideoWebm,
  },
  {
    name: { en: 'PORTAL', fr: 'PORTAIL' },
    title: {
      en: 'Engage with users and <br class="hide-on-small hide-on-large-desktop" /> stakeholders',
      fr: 'Interagissez avec les utilisateurs et les différents stakeholders',
    },
    description: {
      en: 'Share your roadmaps and launches with your audience on a branded portal. Gather feedback seamlessly and validate ideas and concepts.',
      fr: 'Partagez vos roadmap et vos lancements avec votre public cible sur un portail brandé. Recueillez les avis en toute transparence et validez les concepts et les idées.',
    },
    mp4VideoSrc: portalVideoMP4,
    webmVideoSrc: portalVideoWebm,
  },
  {
    name: { en: 'OBJECTIVES & OKRs', fr: 'OBJECTIFS & OKR' },
    title: {
      en: 'Supercharge your product strategy <br class="hide-on-small hide-on-large-desktop" /> with built-in OKRs',
      fr: 'Renforcez votre stratégie produit <br class="hide-on-small hide-on-large-desktop" /> avec des OKR intégrés',
    },
    description: {
      en: "Connect OKRs with your roadmap and product work to drive team alignment. Track multiple teams' progress, from user stories to company-wide objectives — all in one place.",
      fr: "Alignez les OKR avec votre feuille de route et suivez la progression des équipes, du niveau des utilisateurs à l'entreprise, tout en un seul endroit.",
    },
    mp4VideoSrc: okrVideoMP4,
    webmVideoSrc: okrVideoWebm,
  },
  {
    name: { en: 'AI ASSIST', fr: 'IA ASSISTÉE' },
    title: {
      en: 'Unlock the power of AI for <br class="hide-on-small hide-on-large-desktop" /> product managers',
      fr: "Profitez de la puissance de l'AI pour chef de produit",
    },
    description: {
      en: 'Use slash commands to quickly generate ideas or first draft. Summarize and analyze feedback sentiment with our built-in AI and save valuable time.',
      fr: 'Utilisez les commandes “slash” pour générer rapidement des idées ou un premier projet. Résumez et analysez le contenu des feedback grâce à notre IA intégrée et gagnez un temps considérable.',
    },
    mp4VideoSrc: aiVideoMP4,
    webmVideoSrc: aiVideoWebm,
  },
]
